exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-range .react-datepicker-wrapper {\n  display: flex;\n  flex: 1 1;\n  max-width: 160px;\n}\n\n.date-range .react-datepicker__input-container {\n  width: 100%;\n}\n\n@media (max-width: 575px) {\n  .date-range .react-datepicker-wrapper {\n    max-width: 100%;\n  }\n}\n", ""]);

// exports
